import React, { Component } from "react"

import Grid from "@material-ui/core/Grid"
import { ThemeProvider } from '@material-ui/core/styles';
import {TextareaAutosize, withStyles} from "@material-ui/core"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Cookies } from "react-cookie"
import Snackbar from "@material-ui/core/Snackbar"
import Container from "./someCSS/msSMSHandler";

import { Redirect } from "react-router-dom"
import * as constants from "../constants"
import "react-modern-calendar-datepicker/lib/DatePicker.css"

import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Button from "@material-ui/core/Button";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import TableHead from "@material-ui/core/TableHead";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TableBody from "@material-ui/core/TableBody";
import {Multiselect} from "multiselect-react-dropdown";




const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      label: {
            direction: "rtl",
            width: "100%",
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },


      select: {
            searchBox: {
                  // To change search box element look
                  border: "none",
                  fontSize: "35px",
                  minheight: "50px",
            },
            inputField: {
                  // To change input field position or margin
                  margin: "5px",
            },
            chips: {
                  // To change css chips(Selected options)
                  background: "red",
            },
            optionContainer: {
                  // To change css for option container
                  border: "2px solid",
            },
            option: {
                  // To change css for dropdown options
                  color: "black",
            },
      },
      btnsearch: {
            [theme.breakpoints.up("md")]: {
                  width: "120px",
                  height: "40px",
                  fontSize: "15px",
            },
            width: "80px",
            height: "30px",
            fontSize: "13px",
            color: "white",
            backgroundColor: "#41589f",
            //  marginRight:'200px',
            //  marginLeft:'200px',
            marginTop: "30px",
            marginBottom: "10px",
            borderRadius: "4px",
            border: "1px solid #41589f",
      },
})
const ms_style ={
      ms_center: { width: "70%", textAlign:"center", margin:'auto', display:'block', height:"200px"},
      ms_text_field : {textAlign:"center", margin:'auto', display:'inline-block', height:"200px"}
    }
const styleselect = {
      multiselectContainer: {
            // To change css for multiselect (Width,height,etc..)
            fontSize: "14px",
            border: "1.25px solid #bababa",
            borderRadius: "4px",
      },
      searchBox: {
            // To change search box element look
            fontSize: "14px",
            minheight: "50px",
            textAlign: "right",
      },
      inputField: {
            // To change input field position or margin
            margin: "5px",
            fontSize: "14px",
      },
      chips: {
            // To change css chips(Selected options)
            //  background: '#00000000',
            border: "2px solid",
            fontSize: "14px",
      },
      optionContainer: {
            // To change css for option container
            textAlign: "right",

      },
      option: {
            // To change css for dropdown options
            fontSize: "14px",
            textAlign: "right",
      },
      groupHeading: {
            // To chanage group heading style
      },

};



class MySweetSMSLogs extends Component {
      cookies = new Cookies()
      paramsCounter = 0
      regex = new RegExp("^[-a-zA-Z0-9/،?=آ-ی .:_-]+$");
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  smsList : [],
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",

                  allLogs : [],

            }
      }


      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }


      getAll = () =>{
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              // var Company1 = [{ value: 0, label: "همه کارمندان " }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push(arr.data[k])
                              }
                              self.setState(
                                  { allLogs: Company }
                              )
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "getAll")

            xhttp.open("POST", `${constants.BASE_URL}/MySweetSMSLogs`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }







      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            })
      }

      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    /*
                                          SHOULD BE RELACED
                                     */
                                    self.getAll();


                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      onChange = (content) =>{
            console.log('onChange', content);
      }
      render() {
            const self = this

            const { classes } = this.props
            const {
                  redirect,
                  showSnack,
                  snackMode,
                  snackstr,
                  allLogs,

            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (

                  <Container>
                        <Snackbar
                            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                            onClose={this.handleClickcloseTasckBar}
                            open={showSnack}
                            autoHideDuration={10000}
                        >
                              <Alert severity={snackMode}>{snackstr}</Alert>
                        </Snackbar>
                        <Grid container style={{padding: "20px"}} spacing={3}>

                              <Grid item xs={12}>
                                    <Container maxWidth="lg">
                                          <Paper className={classes.root}>
                                                <TableContainer dir="rtl">
                                                      <Table aria-label="sticky table">
                                                            <TableHead>
                                                                  <TableRow>
                                                                        <TableCell
                                                                            key={"log_id"}
                                                                            align={"center"}
                                                                            style={{ minWidth: 20 }}
                                                                        >
                                                                              {" شماره لاگ "}
                                                                        </TableCell>

                                                                        <TableCell
                                                                            key={"mobile"}
                                                                            align={"center"}
                                                                            style={{ minWidth: 20 }}

                                                                        >
                                                                              {" شماره ارسال شده "}

                                                                        </TableCell>

                                                                        <TableCell
                                                                            key={"datetime"}
                                                                            align={"center"}
                                                                            style={{ minWidth: 20 }}

                                                                        >
                                                                              {" تاریخ "}

                                                                        </TableCell>
                                                                        <TableCell
                                                                            key={"content"}
                                                                            align={"center"}
                                                                            style={{ minWidth: 20 }}

                                                                        >
                                                                              {" محتوای پیام "}

                                                                        </TableCell>
                                                                  </TableRow>
                                                            </TableHead>

                                                            <TableBody>
                                                                        {allLogs.map((log) =>{
                                                                              return (
                                                                                <TableRow>
                                                                                      <TableCell
                                                                                          key={"log_id"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {log.my_sweet_sms_log_id}
                                                                                      </TableCell>
                                                                                      <TableCell
                                                                                          key={"moible"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {log.my_sweet_sms_log_mobile}
                                                                                      </TableCell>
                                                                                      <TableCell
                                                                                          key={"datetime"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {log.my_sweet_sms_log_date_time}
                                                                                      </TableCell>
                                                                                      <TableCell
                                                                                          key={"content"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {log.my_sweet_sms_log_content}
                                                                                      </TableCell>
                                                                                </TableRow>
                                                                              );
                                                                        })}
                                                                  </TableBody>
                                                      </Table>
                                                </TableContainer>
                                          </Paper>
                                    </Container>
                              </Grid>

                     </Grid>
                  </Container>

                  )
            }
      }
}

export default withStyles(styles)(MySweetSMSLogs)
